import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import config from 'config';
import './SiteHeader.css';

/* MAIN PAGE HEADER COMPONENT */

const SiteHeader = () => {
  const location = useLocation();

  return (
    <div className="site-name-area">
      <div className="site-name-left">
        <div className="site-name">
          <Link to="/" className="link-to-front">
            {config.site.name}
          </Link>
        </div>
        <div className="site-slogan">
          – {config.site.slogan} –
        </div>
      </div>
      <div className="site-name-right">
        <div className="site-name-seperator"></div>
        <div className="site-name-navigator">
          <Link
            to="/#basic-search-term"
            className={
              location.pathname === '/' ? 'selected' : ''
            }
          >
            <b>HAKU</b>
          </Link>
          <Link
            to="/tietoja"
            className={
              location.pathname === '/tietoja'
                ? 'selected'
                : ''
            }
          >
            <b>TIETOJA LAKITUTKASTA</b>
          </Link>
          <Link
            to="/ohjeet"
            className={
              location.pathname === '/ohjeet'
                ? 'selected'
                : ''
            }
          >
            <b>OHJEET</b>
          </Link>
          <Link
            to="/tutkijalle"
            className={
              location.pathname === '/tutkijalle'
                ? 'selected'
                : ''
            }
          >
            <b>TUTKIJALLE</b>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SiteHeader;
